import { makeAssistantDataUI } from "@assistant-ui/react"
import { AttachmentUI } from "./attachment-ui"
import { ChoiceUI } from "./choice-ui"
import { ConfirmUI } from "./confirm-ui"
import { EntityRefUI } from "./entity-ref-ui"
import { ReferenceUI } from "./reference-ui"
import { ToolCallUI } from "./tool-call-ui"
import type {
  ChatReference,
  ToolCallData,
  UIComponentChoice,
  UIComponentConfirm,
  UIComponentReference,
} from "../../types/assistant.types"

const ChoiceDataUI = makeAssistantDataUI<UIComponentChoice>({
  name: "choice",
  render: (props) => <ChoiceUI data={props.data} />,
})

const ConfirmDataUI = makeAssistantDataUI<UIComponentConfirm>({
  name: "confirm",
  render: (props) => <ConfirmUI data={props.data} />,
})

const ReferenceDataUI = makeAssistantDataUI<UIComponentReference>({
  name: "reference",
  render: (props) => <ReferenceUI data={props.data} />,
})

const EntityRefDataUI = makeAssistantDataUI<ChatReference>({
  name: "chat_reference",
  render: (props) => <EntityRefUI data={props.data} />,
})

const ToolCallDataUI = makeAssistantDataUI<ToolCallData>({
  name: "tool_call",
  render: (props) => <ToolCallUI data={props.data} />,
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AttachmentDataUI = makeAssistantDataUI<any>({
  name: "attachment",
  render: (props) => <AttachmentUI data={props.data} />,
})

export function RegisterDataUIs() {
  return (
    <>
      <ChoiceDataUI />
      <ConfirmDataUI />
      <ReferenceDataUI />
      <EntityRefDataUI />
      <ToolCallDataUI />
      <AttachmentDataUI />
    </>
  )
}
